<script>
export default {
    name: 'IconDegree'
}
</script>
<template>
    <svg
        class="base-icon icon-degree"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 8c9.941 0 18 8.059 18 18 0 5.808-2.751 10.974-7.021 14.265L48 51.885l-5-.514L40 56l-5.096-12.233a18.128 18.128 0 01-5.807 0L24 56l-3-4.629-5 .515 5.021-11.62C16.751 36.973 14 31.807 14 26c0-9.941 8.059-18 18-18zm0 6c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 3l2.833 5L40 23l-3.5 4.167.833 5.833L32 30.333 26.667 33l.833-5.833L24 23l5.167-1L32 17z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
